// @flow

import { loader } from 'graphql.macro';

export const directoriesQuery = loader(
  '../../../../../Settings/screens/DirectoryManagement/queries/FetchDirectoriesQuery.graphql'
);
export const displayNamesQuery = loader('./queries/DisplayNamesQuery.graphql');
export const insightsMaliciousRecipient = loader('./queries/InsightsMaliciousRecipients.graphql');
